"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hydrateFlatDeviceMessage = exports.getFlatDeviceMessage = exports.isFlatDeviceMessage = void 0;
const tslib_1 = require("tslib");
const DeviceTypes_1 = require("../../DeviceTypes");
const dayjs_1 = tslib_1.__importDefault(require("dayjs"));
const utc_1 = tslib_1.__importDefault(require("dayjs/plugin/utc"));
const common_1 = require("../../../common");
dayjs_1.default.extend(utc_1.default);
/**
 * @link https://hal.science/hal-03210318/document
 */
const getESPCalculation = (rssi, snr) => {
    let latter = 10 * Math.log10(1 + Math.pow(10, 0.1 * snr));
    return rssi + snr - latter;
    // calculation through excel
    // let espHalf = Math.pow(rssi / 10, 10) / (1 + Math.pow(snr / 10, 10));
    // return 10 * Math.log10(Math.pow(rssi / 10, 10) - espHalf);
};
const isFlatDeviceMessage = (x) => {
    const c = x;
    return !!c && !!c.deviceEui && !!c.timestamp && !!c.linkType;
};
exports.isFlatDeviceMessage = isFlatDeviceMessage;
const getFlatDeviceMessage = (deviceMessage) => {
    const { primaryGatewayRXData, secondaryGatewayRXData, nmMonitoringAttributes, deviceLocation, resolvedCustomer, resolvedDevice, resolvedEntity, resolvedGroup, resolvedProperty, bearings, ...deviceOthers } = deviceMessage;
    const { gatewayLocation, ...gatewayOthers } = primaryGatewayRXData ?? {};
    const { lat: gatewayLat, lng: gatewayLng, DOP: gatewayDOP } = gatewayLocation ?? {};
    const { position, ...nwMontioringAttributesOthers } = nmMonitoringAttributes ?? {};
    const { lat: deviceLat, lng: deviceLng, DOP: deviceDOP } = deviceLocation ?? position ?? {};
    const { id: entityId, type: entityType, name: entityName } = resolvedEntity ?? {};
    const { id: groupId, name: groupName } = resolvedGroup ?? {};
    const { dailyFCntSkip = 0, dailyMessageCount = 0, yesterdaysFCntJumpTotal = 0, yesterdaysMessageCntTotal = 0 } = resolvedDevice ?? {};
    const { id: customerId, name: customerName } = resolvedCustomer ?? {};
    const { id: propertyId, name: propertyName } = resolvedProperty ?? {};
    const { gatewayToDeviceBearing = undefined, deviceBearing = undefined, deviceToGatewayAngle = undefined } = bearings ?? {};
    const context = {
        entityId,
        entityType,
        entityName,
        groupId,
        groupName,
        customerId,
        dailyFCntSkip,
        dailyMessageCount,
        yesterdaysFCntJumpTotal,
        yesterdaysMessageCntTotal,
        customerName,
        propertyId,
        propertyName,
        gatewayToDeviceBearing,
        deviceBearing,
        deviceToGatewayAngle,
    };
    let otherGatewayEuis = undefined;
    if ((secondaryGatewayRXData?.length ?? 0) > 0 && secondaryGatewayRXData.every((x) => !!x)) {
        otherGatewayEuis = secondaryGatewayRXData.map((gwData) => gwData.gatewayEui).join(',');
    }
    let size = deviceOthers.payloadStr?.length;
    let esp = undefined;
    if (gatewayOthers.rssi && gatewayOthers.snr) {
        esp = getESPCalculation(gatewayOthers.rssi, gatewayOthers.snr);
    }
    const flatRecord = {
        ...deviceOthers,
        ...gatewayOthers,
        ...nwMontioringAttributesOthers,
        ...context,
        esp,
        size,
        otherGatewayEuis,
        deviceLat,
        deviceLng,
        deviceDOP,
        gatewayLat,
        gatewayLng,
        gatewayDOP,
    };
    return flatRecord;
};
exports.getFlatDeviceMessage = getFlatDeviceMessage;
const hydrateFlatDeviceMessage = (flatMessage) => {
    const { adr, app_id, antenna, bw, channel, channel_rssi, codeRate, consumedAirtimeSecs, correlation_ids, customerId, customerName, deviceEui, deviceId, deviceName, dr, entityId, entityName, entityType, propertyId, propertyName, esp, frequency, gatewayEui, gatewayIdName, groupId, groupName, joinEui, linkType, modulation, nwID, otherGatewayEuis, payloadStr, port, power, rfChain, rssi, sf, size, snr, timestamp, uplinkId, DOP, age, battery, batteryCharging, batteryErr, deviceLocation, deviceType, downlinkAck, elevation, fCnt, fCntInc, lat, linkCheckErr, lng, nasSourceIp, reboot, dailyFCntSkip = 0, dailyMessageCount = 0, yesterdaysFCntJumpTotal, yesterdaysMessageCntTotal, deviceLat, deviceLng, deviceDOP, gatewayLat, gatewayLng, gatewayDOP, gatewayToDeviceBearing, deviceBearing, deviceToGatewayAngle, } = flatMessage;
    const position = deviceLat && deviceLng ? { lat: deviceLat, lng: deviceLng, DOP: deviceDOP, elevation, age } : undefined;
    const nmMonitoringAttributes = {
        battery,
        batteryCharging,
        batteryErr,
        reboot,
        downlinkAck,
        linkCheckErr,
        position,
    };
    const gatewayLocation = gatewayLat && gatewayLng ? { lat: gatewayLat, lng: gatewayLng, DOP: gatewayDOP } : undefined;
    const primaryGatewayRXData = {
        antenna,
        channel,
        channel_rssi,
        gatewayEui,
        gatewayIdName,
        gatewayLocation,
        rssi,
        rfChain,
        snr,
        esp,
    };
    /* 2025 04 RSE removed WYC added predicate that dailyFCntSkip and dailyMessageCount must be defined as that is clearly not what resolvedDevice should be. */
    const resolvedDevice = {
        id: deviceEui,
        deviceId,
        appID: app_id,
        deviceType: deviceType ?? DeviceTypes_1.DeviceTypes.GenericSensor,
        eui: deviceEui,
        networkKey: nwID,
        type: 'Device',
        dailyFCntSkip,
        dailyMessageCount,
        yesterdaysFCntJumpTotal,
        yesterdaysMessageCntTotal,
    };
    const resolvedEntity = entityId && entityType && entityName ? { id: entityId, type: entityType, name: entityName } : undefined;
    const resolvedGroup = groupId && groupName ? { id: groupId, type: 'Group', name: groupName } : undefined;
    const resolvedProperty = propertyId && propertyName ? { id: propertyId, type: 'Property', name: propertyId } : undefined;
    const resolvedCustomer = customerId && customerName ? { id: customerId, type: 'Customer', name: customerName } : undefined;
    const bearings = { gatewayToDeviceBearing, deviceBearing, deviceToGatewayAngle };
    const deviceMessage = {
        adr,
        app_id,
        bw,
        codeRate,
        consumedAirtimeSecs,
        correlation_ids,
        deviceEui,
        deviceId,
        deviceName,
        dr,
        frequency,
        joinEui,
        linkType,
        modulation,
        nmMonitoringAttributes,
        nwID,
        payloadStr,
        port,
        power,
        secondaryGatewayRXData: [] /** Provisonally we will decide to join this with Gateway data table if requred */,
        sf,
        /** Parquet date strings are UTC but don't specify the the TZ so dayjs.utc is used to enforce */
        timestamp: typeof timestamp === 'number' ? timestamp : timestamp instanceof Date ? timestamp.valueOf() : dayjs_1.default.utc(timestamp).unix() * common_1.Milliseconds.SECOND,
        uplinkId,
        deviceLocation,
        deviceType,
        fCnt,
        fCntInc,
        nasSourceIp,
        primaryGatewayRXData,
        resolvedDevice,
        resolvedCustomer,
        resolvedEntity,
        resolvedGroup,
        resolvedProperty,
        bearings,
    };
    return deviceMessage;
};
exports.hydrateFlatDeviceMessage = hydrateFlatDeviceMessage;
